/* Exhausty — painel "Também te pode interessar" (ao lado da gaveta do carrinho). */
(function () {
  if (window.__xupPanel) return;
  window.__xupPanel = true;

  var MAX_ITEMS = 6;
  var MAX_PONTEIRAS = 3;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function readJSON(sel) {
    var el = $(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'pt-PT', { style: 'currency', currency: 'EUR' });
  }
  /* Textos vêm de locales (exh.upsell.*): o filtro t escapa entidades, por isso descodificamos os textos simples. */
  function i18n() {
    var o = readJSON('[data-xup-i18n]') || {}, x = document.createElement('textarea');
    Object.keys(o).forEach(function (k) { if (k !== 'hint_none' && k !== 'hint_full' && typeof o[k] === 'string') { x.innerHTML = o[k]; o[k] = x.value; } });
    return o;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Calcula o escalão do próximo artigo, igual às regras dos descontos automáticos. */
  function computeState(items) {
    var base = 0, acc = 0, comp = false, main = null;
    items.forEach(function (it) {
      if (it.base) base += it.qty;
      if (it.acess) acc += it.qty;
      if (it.comp) comp = true;
      if (it.base && !main && (it.linha || (it.sug && it.sug.length))) main = it;
    });
    if (!main) main = items.filter(function (it) { return it.base; })[0] || null;
    var full = comp || base >= 2;
    var extras = acc + (full ? Math.max(0, base - (comp ? 1 : 2)) : 0);
    var accPct = 0, pontPct = 0;
    if (base >= 1) {
      /* Só o 1.º artigo extra tem desconto: 10% sem escape completo, 12% com escape completo. */
      if (!full) accPct = acc === 0 ? 10 : 0;
      else {
        accPct = extras === 0 ? 12 : 0;
        pontPct = extras === 0 ? 12 : 0;
      }
    }
    return { base: base, full: full, main: main, accPct: accPct, pontPct: pontPct };
  }

  function card(p, pct, t) {
    var price = p.price || 0;
    var newPrice = pct ? Math.round(price * (100 - pct) / 100) : price;
    var action;
    if (!p.available) action = '<span class="xup-card__link">' + esc(t.sold_out) + '</span>';
    else if (p.multi) action = '<a class="xup-card__link" href="' + esc(p.url) + '">' + esc(t.options) + '</a>';
    else action = '<button type="button" class="xup-card__btn" data-xup-add="' + esc(p.variant_id) + '">' + esc(t.add) + '</button>';
    return '<li class="xup-card">' +
      (pct ? '<span class="xup-card__badge">-' + pct + '%</span>' : '') +
      '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="72" height="72">' +
      '<div><a class="xup-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="xup-card__prices"><span class="xup-card__new">' + money(newPrice) + '</span>' +
      (pct ? '<span class="xup-card__old">' + money(price) + '</span>' : '') + '</div>' +
      action + '</div></li>';
  }

  function render() {
    var data = readJSON('[data-xup-data]');
    var t = i18n();
    var panels = document.querySelectorAll('[data-xup-panel]');
    if (!panels.length) return;
    var html = '';
    if (data && data.items && data.items.length) {
      var st = computeState(data.items);
      if (st.main) {
        var inCart = {};
        data.items.forEach(function (it) { inCart[it.product_id] = true; });
        var seen = {};
        var list = [];
        if (st.full && st.pontPct && (st.main.linha === 'curta' || st.main.linha === 'longa')) {
          (data.ponteiras || []).filter(function (x) { return x.tipo === st.main.linha; })
            .forEach(function (x) {
              if (list.length < MAX_PONTEIRAS && !inCart[x.p.id] && !seen[x.p.id]) { seen[x.p.id] = 1; list.push({ p: x.p, pct: st.pontPct }); }
            });
        }
        (st.main.sug || []).concat(data.generic || []).forEach(function (p) {
          if (list.length < MAX_ITEMS && p && !inCart[p.id] && !seen[p.id]) { seen[p.id] = 1; list.push({ p: p, pct: st.accPct }); }
        });
        if (list.length) {
          var pct = st.accPct || st.pontPct;
          var hint = pct ? (st.full ? t.hint_full : t.hint_none).replace('{pct}', '-' + pct + '%') : '';
          html = '<div class="xup-panel__head"><p class="xup-panel__title">' + esc(t.title) + '</p>' +
            (hint ? '<p class="xup-panel__hint">' + hint + '</p>' : '') + '</div>' +
            '<ul class="xup-panel__list">' + list.map(function (x) { return card(x.p, x.pct, t); }).join('') + '</ul>';
        }
      }
    }
    panels.forEach(function (el) {
      el.innerHTML = html;
      el.hidden = !html;
    });
    syncWidth();
  }

  function syncWidth() {}

  function add(btn) {
    var t = i18n();
    btn.disabled = true;
    btn.textContent = t.adding || '…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-xup-add')), quantity: 1 }] })
    }).then(function () {
      var drawer = $('m-cart-drawer');
      if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
      else window.location.reload();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = t.add || 'Add';
    });
  }

  function init() {
    var inner = $('.m-cart-drawer__inner');
    var side = $('[data-xup-panel="side"]');
    if (inner && side && side.parentNode !== inner) inner.insertBefore(side, inner.firstChild);
    document.querySelectorAll('[data-xup-panel]').forEach(function (el) {
      /* A gaveta fecha-se com cliques fora dela: o painel não deve contar como "fora". */
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        var btn = e.target.closest('[data-xup-add]');
        if (btn) { e.preventDefault(); add(btn); }
      });
    });
    var items = $('[data-minimog-cart-items]');
    if (items && window.MutationObserver) {
      new MutationObserver(function () { render(); }).observe(items, { childList: true, subtree: true });
    }
    window.addEventListener('resize', syncWidth);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
